import React from 'react';
import styled from "styled-components";

const StyledTab = styled.div`
  margin-right: 3rem;
  color: white;
  font-size: 3rem;
  cursor: pointer;
  ${(props) => props.type.value === props.value ? 'border-bottom: 2px solid white' : 'border-bottom: none'}
`

const TransactionSwitch = ({type, setType}) => {
  const UNRECONCILED = {value: 'UNRECONCILED', label: 'Unreconciled'}
  const RECONCILED = {value: 'RECONCILED', label: 'Pending'}
  const APPROVED_RECONCILED = {value: 'APPROVED', label: 'Approved Transactions'}

  const handleClick = (concileType) => {
    setType(concileType);
  }

  return (
    <div className={'tab-selection'}>
      <StyledTab type={type} value={UNRECONCILED.value} onClick={() => handleClick(UNRECONCILED)} className={`tab`}>Unreconciled</StyledTab>
      <StyledTab type={type} value={RECONCILED.value} onClick={() => handleClick(RECONCILED)} className={`tab`}>Pending Reconciled</StyledTab>
      {/*<StyledTab type={type} value={APPROVED_RECONCILED.value} onClick={() => handleClick(APPROVED_RECONCILED)} className={`tab`}>Approved</StyledTab>*/}
    </div>
  )
}

export default TransactionSwitch;